import ContentLoader from 'react-content-loader'
import React from 'react'

export default function HelpLoader(props) {
  return (
    <ContentLoader width='100%' height='80' backgroundColor='rgba(255, 255, 255, 0.2)' foregroundColor='rgba(255, 255, 255, 0.05)' {...props}>
      <rect x='0' y='8' rx='4' ry='4' width='90%' height='20' />
      <rect x='0' y='33' rx='4' ry='4' width='75%' height='10' />
      <circle cx="15" cy="65" r="15" />
    </ContentLoader>
  )
}
